import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PCrossLabelComponent } from './p-cross-label.component';

@NgModule({
    declarations: [PCrossLabelComponent],
    imports: [CommonModule],
    exports: [PCrossLabelComponent]
})
export class PCrossLabelModule {}
